'use strict';

/**
 * Message that signals the departure of the sender.
 */
class MLeave {
    constructor () {
        this.type = 'MLeave';
    };
};

module.exports = MLeave;
